// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2nm0G","col":"Table_col__3IMil","fulfillmentStatus":"Table_fulfillmentStatus__2la0z","emailCol":"Table_emailCol__3-Uc9"};